'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = _interopDefault(require('react'));
var PropTypes = _interopDefault(require('prop-types'));
var classNames = _interopDefault(require('classnames'));
var Link = _interopDefault(require('next/link'));
var uuid = require('uuid');
var dayjs = _interopDefault(require('dayjs'));
var utc = _interopDefault(require('dayjs/plugin/utc'));
var timezone = _interopDefault(require('dayjs/plugin/timezone'));

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}

var _excluded = ["href", "as", "children", "className", "activeClassName", "currentPath"];

// NOTE: this component does not support hash links (internal anchor links)
//       because reach router doesn't support them. If support becomes
//       available or switching to react-router-v4+ HashLink component,
//       this component can be modified to support them.

var TitanLink = function TitanLink(props) {
  var href = props.href,
    as = props.as,
    children = props.children,
    className = props.className,
    activeClassName = props.activeClassName,
    currentPath = props.currentPath,
    rest = _objectWithoutProperties(props, _excluded);
  var protocolReg = /^(http:\/\/|https:\/\/|\/\/)/;

  // Checks for 'http://', 'https://', or '//' at the beginning of a string
  function isExternalUrl(url) {
    return protocolReg.test(url);
  }
  var fullClassName = className;
  if (activeClassName && currentPath == href) {
    fullClassName = className ? "".concat(className, " ").concat(activeClassName) : activeClassName;
  }
  if (isExternalUrl(href)) {
    return /*#__PURE__*/React.createElement("a", _extends({
      href: href
    }, rest, {
      className: fullClassName,
      "data-testid": "externalLink"
    }), children);
  } else {
    return /*#__PURE__*/React.createElement(Link, _extends({}, rest, {
      href: href,
      as: as,
      className: fullClassName,
      "data-testid": "relativeLink"
    }), children);
  }
};
TitanLink.propTypes = {
  // Children are required because even if the link is styled with a class it should have text inside for accessibility
  children: PropTypes.any.isRequired,
  href: PropTypes.string.isRequired,
  as: PropTypes.string,
  className: PropTypes.string,
  activeClassName: PropTypes.string,
  currentPath: PropTypes.string
};

var _excluded$1 = ["as", "children", "disabled", "elementClass", "href", "newWindow", "size", "submitForm", "type"];
var Button = function Button(_ref) {
  var _classNames;
  var as = _ref.as,
    children = _ref.children,
    disabled = _ref.disabled,
    elementClass = _ref.elementClass,
    href = _ref.href,
    newWindow = _ref.newWindow,
    size = _ref.size,
    submitForm = _ref.submitForm,
    type = _ref.type,
    rest = _objectWithoutProperties(_ref, _excluded$1);
  var classes = classNames((_classNames = {
    btn: true
  }, _defineProperty(_classNames, "btn-".concat(type), type), _defineProperty(_classNames, "btn-".concat(size), size), _defineProperty(_classNames, "disabled", disabled), _defineProperty(_classNames, elementClass, elementClass), _classNames));
  if (href) {
    if (disabled) {
      return /*#__PURE__*/React.createElement("span", {
        className: classes,
        disabled: disabled
      }, children);
    } else {
      return /*#__PURE__*/React.createElement(TitanLink, _extends({
        href: href,
        as: as,
        className: classes,
        target: newWindow ? '_blank' : null,
        rel: newWindow ? 'noopener noreferrer' : null
      }, rest), children);
    }
  } else {
    return /*#__PURE__*/React.createElement("button", _extends({
      className: classes,
      disabled: disabled,
      type: submitForm ? 'submit' : 'button'
    }, rest), children);
  }
};
Button.propTypes = {
  as: PropTypes.any,
  children: PropTypes.any.isRequired,
  disabled: PropTypes.bool,
  elementClass: PropTypes.string,
  href: PropTypes.string,
  /** newWindow only applies to Link buttons, adds target="_blank" */
  newWindow: PropTypes.bool,
  size: PropTypes.oneOf(['large', 'small']),
  /** if submitForm == true, adds type="submit" to <button> */
  submitForm: PropTypes.bool,
  type: PropTypes.oneOf(['primary', 'secondary', 'destructive'])
};

var Figure = function Figure(_ref) {
  var _classNames;
  var elementClass = _ref.elementClass,
    image = _ref.image,
    caption = _ref.caption,
    size = _ref.size,
    position = _ref.position,
    credit = _ref.credit,
    creditHref = _ref.creditHref,
    isAmp = _ref.isAmp;
  var classes = classNames((_classNames = {
    figure: true
  }, _defineProperty(_classNames, "figure-".concat(position), position), _defineProperty(_classNames, "figure-".concat(size), size), _defineProperty(_classNames, elementClass, elementClass), _classNames));
  var styles = {
    figure: {
      margin: 0
    }
  };
  function captionCredit() {
    if (credit && creditHref) {
      return /*#__PURE__*/React.createElement("a", {
        href: creditHref,
        className: "figure_credit"
      }, credit);
    } else if (credit) {
      return /*#__PURE__*/React.createElement("div", {
        className: "figure_credit"
      }, credit);
    }
  }
  return /*#__PURE__*/React.createElement("figure", {
    className: classes,
    style: isAmp ? styles.figure : {}
  }, image, caption || credit ? /*#__PURE__*/React.createElement("figcaption", {
    className: "figure_caption"
  }, caption && /*#__PURE__*/React.createElement("div", {
    className: "figure_text"
  }, caption), captionCredit()) : '');
};
Figure.defaultProps = {
  size: 'full'
};
Figure.propTypes = {
  elementClass: PropTypes.string,
  image: PropTypes.element.isRequired,
  caption: PropTypes.string,
  size: PropTypes.string,
  position: PropTypes.string,
  credit: PropTypes.string,
  creditHref: PropTypes.string,
  isAmp: PropTypes.bool
};

var Heading = function Heading(_ref) {
  var _classNames;
  var elementClass = _ref.elementClass,
    className = _ref.className,
    children = _ref.children,
    level = _ref.level;
  // This component is for semantically providing h1 - h6
  // depending on the html document outline.
  // By default the `hdg-*` class will match the level,
  // but to visually change the size, pass in classes
  // through the `className` prop

  var classes = classNames((_classNames = {
    hdg: !className
  }, _defineProperty(_classNames, "hdg-".concat(level), !className && level), _defineProperty(_classNames, className, className), _defineProperty(_classNames, elementClass, elementClass), _classNames));
  var Hdg = "h".concat(level);
  return /*#__PURE__*/React.createElement(Hdg, {
    className: classes
  }, children);
};
Heading.propTypes = {
  children: PropTypes.node,
  elementClass: PropTypes.string,
  className: PropTypes.string,
  level: PropTypes.oneOf([1, 2, 3, 4, 5, 6]).isRequired
};

var Loading = function Loading() {
  return /*#__PURE__*/React.createElement("div", {
    className: "spinner"
  }, /*#__PURE__*/React.createElement("span", {
    className: "invisible"
  }, "Loading"));
};

function toSentence(arr) {
  if (!arr || arr.length === 0) {
    return;
  }
  if (arr.length === 1) {
    return arr[0];
  } else if (arr.length === 2) {
    return "".concat(arr[0], " and ").concat(arr[1]);
  }
  var last = arr.pop();
  return "".concat(arr.join(', '), ", and ").concat(last);
}

// Get the previous index OR min
function prevIndex(i) {
  if (i === 2) return '';
  return i > 1 ? i - 1 : 1;
}

// Get the next index OR max
function nextIndex(i, count) {
  return i < count ? i + 1 : count;
}

// Returns youtube video id
function youtubeParser(url) {
  var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
  var match = url.match(regExp);
  return match && match[7].length == 11 ? match[7] : false;
}

// Return playerEmbed determined by type of primary video source
function getVideoPlayer(video) {
  var playerEmbed;
  var uri = new URL(video.url);
  switch (uri.hostname) {
    case 'www.facebook.com':
      playerEmbed = /*#__PURE__*/React.createElement("div", {
        className: "iframe-container"
      }, /*#__PURE__*/React.createElement("iframe", {
        title: video.credit.name,
        src: "https://www.facebook.com/plugins/video.php?href=".concat(video.url, "&show_text=0"),
        scrolling: "no",
        frameBorder: "0",
        allowFullScreen: true
      }));
      break;
    case 'player.vimeo.com':
    case 'mpr.apmcdn.org':
      playerEmbed = /*#__PURE__*/React.createElement("video", {
        id: video.credit.name,
        autoPlay: true,
        muted: true,
        loop: true
      }, /*#__PURE__*/React.createElement("source", {
        src: video.url,
        type: "video/mp4"
      }), "Your browser does not support HTML5 video.");
      break;
    case 'www.youtube.com':
      // eslint-disable-next-line jsx-a11y/iframe-has-title
      playerEmbed = /*#__PURE__*/React.createElement("div", {
        className: "iframe-container"
      }, /*#__PURE__*/React.createElement("iframe", {
        title: video.credit.name,
        src: "https://www.youtube.com/embed/".concat(youtubeParser(video.url))
      }));
      break;
    default:
      console.error(playerEmbed, 'source is not a valid video url');
  }
  return playerEmbed;
}

var Pagination = function Pagination(_ref) {
  var elementClass = _ref.elementClass,
    prevNextClass = _ref.prevNextClass,
    firstLastClass = _ref.firstLastClass,
    numberClass = _ref.numberClass,
    currentNumberClass = _ref.currentNumberClass,
    currentPage = _ref.currentPage,
    totalPages = _ref.totalPages,
    buffer = _ref.buffer,
    hrefPrefix = _ref.hrefPrefix,
    asPrefix = _ref.asPrefix,
    hasFirstAndLast = _ref.hasFirstAndLast,
    inclusiveFirstLast = _ref.inclusiveFirstLast,
    firstLastSeparator = _ref.firstLastSeparator,
    firstSymbol = _ref.firstSymbol,
    prevSymbol = _ref.prevSymbol,
    nextSymbol = _ref.nextSymbol,
    lastSymbol = _ref.lastSymbol,
    middleSymbol = _ref.middleSymbol;
  var classes = classNames(_defineProperty({
    pagination: true
  }, elementClass, elementClass));
  var firstLinkClasses = classNames(_defineProperty({
    pagination_link: true,
    'pagination_link-first': true
  }, firstLastClass, firstLastClass));
  var prevLinkClasses = classNames(_defineProperty({
    pagination_link: true,
    'pagination_link-prev': true
  }, prevNextClass, prevNextClass));
  var nextLinkClasses = classNames(_defineProperty({
    pagination_link: true,
    'pagination_link-next': true
  }, prevNextClass, prevNextClass));
  var lastLinkClasses = classNames(_defineProperty({
    pagination_link: true,
    'pagination_link-last': true
  }, firstLastClass, firstLastClass));
  var paginationArray = [];
  Array(buffer * 2 + 1).fill(0).forEach(function (val, i) {
    var value = i + currentPage - buffer;
    if (value > 0 && value <= totalPages) paginationArray.push(value);
  });
  var showFirst = function showFirst() {
    if (hasFirstAndLast) {
      if (inclusiveFirstLast && currentPage > 1 + buffer) {
        return true;
      } else if (!inclusiveFirstLast && currentPage >= 1) {
        return true;
      } else if (middleSymbol && currentPage >= 1) {
        return true;
      } else return false;
    } else {
      return false;
    }
  };
  var showLast = function showLast() {
    if (hasFirstAndLast) {
      if (inclusiveFirstLast && currentPage < totalPages - buffer) {
        return true;
      } else if (!inclusiveFirstLast && currentPage <= totalPages) {
        return true;
      } else if (middleSymbol && currentPage >= 1) {
        return true;
      } else return false;
    } else {
      return false;
    }
  };
  var currentNumOrFirstNum = middleSymbol ? "".concat(asPrefix).concat(currentPage === 1 ? '' : "/".concat(currentPage)) : "".concat(asPrefix);
  return /*#__PURE__*/React.createElement("nav", {
    "data-testid": "pagination-test",
    className: classes
  }, /*#__PURE__*/React.createElement("ul", {
    className: "pagination_list"
  }, showFirst() && /*#__PURE__*/React.createElement("li", {
    className: "pagination_page pagination_page-first"
  }, /*#__PURE__*/React.createElement(TitanLink, {
    href: "/".concat(hrefPrefix),
    as: currentNumOrFirstNum,
    className: firstLinkClasses
  }, firstSymbol), firstLastSeparator && currentPage > buffer + 2 && /*#__PURE__*/React.createElement("span", {
    className: "pagination_separator pagination_separator-first"
  }, firstLastSeparator), middleSymbol && middleSymbol), currentPage > 1 && /*#__PURE__*/React.createElement("li", {
    className: "pagination_page pagination_page-prev"
  }, /*#__PURE__*/React.createElement(TitanLink, {
    href: "/".concat(asPrefix, "/").concat(prevIndex(currentPage)),
    className: prevLinkClasses
  }, prevSymbol)), !middleSymbol && paginationArray.map(function (value) {
    var _classNames6;
    var pageClasses = classNames({
      pagination_page: true,
      'pagination_page-number': true,
      'pagination_page-current': currentPage === value
    });
    var linkClasses = classNames((_classNames6 = {
      pagination_link: true,
      'pagination_link-number': true,
      'pagination_link-current': currentPage === value
    }, _defineProperty(_classNames6, numberClass, numberClass), _defineProperty(_classNames6, currentNumberClass, currentNumberClass && currentPage === value), _classNames6));
    return /*#__PURE__*/React.createElement("li", {
      key: uuid.v4(),
      className: pageClasses
    }, /*#__PURE__*/React.createElement(TitanLink, {
      href: "/".concat(hrefPrefix),
      as: "/".concat(asPrefix).concat(value === 1 ? '' : "/".concat(value)),
      className: linkClasses
    }, value));
  }), currentPage < totalPages && /*#__PURE__*/React.createElement("li", {
    className: "pagination_page pagination_page-next"
  }, /*#__PURE__*/React.createElement(TitanLink, {
    href: "/".concat(hrefPrefix),
    as: "/".concat(asPrefix, "/").concat(nextIndex(currentPage, totalPages)),
    className: nextLinkClasses
  }, nextSymbol)), showLast() && /*#__PURE__*/React.createElement("li", {
    className: "pagination_page pagination_page-last"
  }, firstLastSeparator && currentPage < totalPages - buffer - 1 && /*#__PURE__*/React.createElement("span", {
    className: "pagination_separator pagination_separator-last"
  }, firstLastSeparator), /*#__PURE__*/React.createElement(TitanLink, {
    href: "/".concat(hrefPrefix),
    as: "/".concat(asPrefix, "/").concat(totalPages),
    className: lastLinkClasses
  }, lastSymbol))));
};
Pagination.propTypes = {
  elementClass: PropTypes.string,
  prevNextClass: PropTypes.string,
  firstLastClass: PropTypes.string,
  numberClass: PropTypes.string,
  currentNumberClass: PropTypes.string,
  currentPage: PropTypes.number.isRequired,
  hrefPrefix: PropTypes.string.isRequired,
  asPrefix: PropTypes.string.isRequired,
  buffer: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
  hasFirstAndLast: PropTypes.bool,
  inclusiveFirstLast: PropTypes.bool,
  firstLastSeparator: PropTypes.string,
  firstSymbol: PropTypes.any,
  prevSymbol: PropTypes.any,
  nextSymbol: PropTypes.any,
  lastSymbol: PropTypes.any,
  middleSymbol: PropTypes.any
};
Pagination.defaultProps = {
  hasFirstAndLast: true,
  prevSymbol: '〈',
  nextSymbol: '〉',
  firstSymbol: '《',
  lastSymbol: '》'
};

var TagLink = function TagLink(_ref) {
  var elementClass = _ref.elementClass,
    href = _ref.href,
    tagName = _ref.tagName;
  var classes = classNames(_defineProperty({
    tag: true
  }, elementClass, elementClass));
  return /*#__PURE__*/React.createElement(Link, {
    href: href,
    className: classes
  }, tagName);
};
TagLink.propTypes = {
  elementClass: PropTypes.string,
  href: PropTypes.string.isRequired,
  tagName: PropTypes.string.isRequired
};

dayjs.extend(utc);
dayjs.extend(timezone);
var Time = function Time(props) {
  // If this date string is formatted like our CMS formats it, use the constructTime function above. Otherwise, just parse the date normally. Parsing our CMSs timestamps directly with new Date(string) didn't behave well with the time zone stuff.
  var cmsDateStampRegex = /\d\d\d\d-[01]\d-[0123]\dT[012]\d:[012345]\d/;
  var time = cmsDateStampRegex.test(props.dateTime) ? new Date(props.dateTime).toLocaleString('en-US', {
    timeZone: 'America/Chicago'
  }) : new Date(props.dateTime);
  if (props.type === 'distance') {
    return /*#__PURE__*/React.createElement("time", {
      className: props.elementClass && props.elementClass,
      dateTime: props.dateTime,
      title: dayjs(time).format('MMMM D, YYYY h:mm A')
    }, "".concat(Math.abs(dayjs(time).diff(dayjs(), props.distanceFormat)), " ").concat(props.distanceFormat, "s"));
  } else {
    return /*#__PURE__*/React.createElement("time", {
      className: props.elementClass && props.elementClass,
      dateTime: props.dateTime
    }, dayjs(time).format(props.formatString));
  }
};
Time.defaultProps = {
  type: 'timestamp',
  formatString: 'MMMM D, YYYY h:mm A',
  distanceFormat: 'day'
};
Time.propTypes = {
  dateTime: PropTypes.string.isRequired,
  elementClass: PropTypes.string,
  formatString: PropTypes.string,
  distanceFormat: PropTypes.string,
  type: PropTypes.oneOf(['timestamp', 'distance'])
};

// Amat's (ruby) repo: https://gitlab.mpr.org/cms-prototype/amat

var Body = function Body(_ref) {
  var bodyHtml = _ref.bodyHtml,
    elementClass = _ref.elementClass;
  var classes = classNames(_defineProperty({
    userContent: true
  }, elementClass, elementClass));
  var markup = function markup() {
    return {
      __html: bodyHtml
    };
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes,
    dangerouslySetInnerHTML: markup()
  });
};
Body.propTypes = {
  elementClass: PropTypes.string,
  bodyHtml: PropTypes.string.isRequired
};

var toByline = function toByline(authors) {
  if (!authors || authors.length <= 0) return;
  if (authors.length === 1) {
    return /*#__PURE__*/React.createElement("div", {
      className: "content_byline",
      "data-testid": "contentByline"
    }, "By ", /*#__PURE__*/React.createElement(Link, {
      href: authors[0].href
    }, "".concat(authors[0].name)));
  } else if (authors.length === 2) {
    return /*#__PURE__*/React.createElement("div", {
      className: "content_byline",
      "data-testid": "contentByline"
    }, "By ", /*#__PURE__*/React.createElement(Link, {
      href: authors[0].href
    }, "".concat(authors[0].name)), " and ", /*#__PURE__*/React.createElement(Link, {
      href: authors[1].href
    }, "".concat(authors[1].name)));
  } else {
    return /*#__PURE__*/React.createElement("div", {
      className: "content_byline",
      "data-testid": "contentByline"
    }, 'By ', authors.slice(0, authors.length - 2).map(function (author) {
      return /*#__PURE__*/React.createElement("span", {
        key: author.href
      }, /*#__PURE__*/React.createElement(Link, {
        href: author.href
      }, "".concat(author.name)), ", ");
    }), /*#__PURE__*/React.createElement(Link, {
      href: authors[authors.length - 2].href
    }, "".concat(authors[authors.length - 2].name)), " and ", /*#__PURE__*/React.createElement(Link, {
      href: authors[authors.length - 1].href
    }, "".concat(authors[authors.length - 1].name)));
  }
};
var ContentHeader = function ContentHeader(_ref) {
  var title = _ref.title,
    subtitle = _ref.subtitle,
    tag = _ref.tag,
    headingLevel = _ref.headingLevel,
    authors = _ref.authors,
    publishDate = _ref.publishDate;
  return /*#__PURE__*/React.createElement("header", {
    className: "content_header"
  }, tag && /*#__PURE__*/React.createElement(TagLink, {
    href: tag.href,
    tagName: tag.tagName,
    elementClass: "content_topic"
  }), /*#__PURE__*/React.createElement(Heading, {
    level: headingLevel ? headingLevel : 1
  }, title), subtitle && /*#__PURE__*/React.createElement("p", {
    className: "content_subtitle",
    "data-testid": "contentSubtitle"
  }, subtitle), /*#__PURE__*/React.createElement("div", {
    className: "content_meta"
  }, authors && toByline(authors), publishDate));
};
ContentHeader.propTypes = {
  authors: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    href: PropTypes.string
  })),
  headingLevel: PropTypes.number,
  publishDate: PropTypes.node,
  subtitle: PropTypes.string,
  tag: PropTypes.shape({
    href: PropTypes.string,
    tagName: PropTypes.string
  }),
  title: PropTypes.string.isRequired
};

var Content = function Content(_ref) {
  var title = _ref.title,
    subtitle = _ref.subtitle,
    authors = _ref.authors,
    headingLevel = _ref.headingLevel,
    publishDate = _ref.publishDate,
    tag = _ref.tag,
    image = _ref.image,
    imageCaption = _ref.imageCaption,
    imageCredit = _ref.imageCredit,
    imageCreditHref = _ref.imageCreditHref,
    bodyHtml = _ref.bodyHtml;
  return /*#__PURE__*/React.createElement("article", {
    className: "content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col col-page"
  }, /*#__PURE__*/React.createElement(ContentHeader, {
    title: title,
    authors: authors,
    headingLevel: headingLevel,
    publishDate: publishDate,
    subtitle: subtitle,
    tag: tag
  })), image && /*#__PURE__*/React.createElement(Figure, {
    image: image,
    caption: imageCaption,
    credit: imageCredit,
    creditHref: imageCreditHref
  }), bodyHtml && /*#__PURE__*/React.createElement("div", {
    className: "col col-content"
  }, /*#__PURE__*/React.createElement(Body, {
    bodyHtml: bodyHtml
  })));
};
Content.propTypes = {
  authors: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    href: PropTypes.string
  })),
  headingLevel: PropTypes.number,
  publishDate: PropTypes.node,
  subtitle: PropTypes.string,
  bodyHtml: PropTypes.string,
  image: PropTypes.object,
  imageCaption: PropTypes.string,
  imageCredit: PropTypes.string,
  imageCreditHref: PropTypes.string,
  tag: PropTypes.shape({
    title: PropTypes.string,
    href: PropTypes.string
  }),
  title: PropTypes.string.isRequired
};

var EventHeader = function EventHeader(_ref) {
  var title = _ref.title,
    subtitle = _ref.subtitle,
    tag = _ref.tag,
    headingLevel = _ref.headingLevel,
    publishDate = _ref.publishDate;
  return /*#__PURE__*/React.createElement("header", {
    className: "event_header"
  }, tag && /*#__PURE__*/React.createElement(TagLink, {
    href: tag.href,
    tagName: tag.tagName,
    elementClass: "event_topic"
  }), /*#__PURE__*/React.createElement(Heading, {
    level: headingLevel ? headingLevel : 1,
    className: "hdg hdg-1"
  }, title), subtitle && /*#__PURE__*/React.createElement("p", {
    className: "event_subtitle",
    "data-testid": "eventSubtitle"
  }, subtitle), publishDate && /*#__PURE__*/React.createElement("div", {
    className: "event_meta"
  }, publishDate));
};
EventHeader.propTypes = {
  title: PropTypes.string.isRequired,
  headingLevel: PropTypes.number,
  publishDate: PropTypes.node,
  subtitle: PropTypes.string,
  tag: PropTypes.shape({
    href: PropTypes.string,
    tagName: PropTypes.string
  })
};

var EventVenue = function EventVenue(_ref) {
  var venue = _ref.venue;
  return /*#__PURE__*/React.createElement("div", {
    className: "eventInfo-venue"
  }, /*#__PURE__*/React.createElement("h2", null, "Location"), /*#__PURE__*/React.createElement("a", {
    href: venue.website,
    target: "_blank",
    rel: "noopener noreferrer",
    className: "link-plain"
  }, venue.name), /*#__PURE__*/React.createElement("address", null, venue.street, " ", venue.city, ", ", venue.state, /*#__PURE__*/React.createElement("br", null), venue.zip, /*#__PURE__*/React.createElement("br", null), venue.phone), venue.latitude && venue.longitude && /*#__PURE__*/React.createElement("a", {
    href: "https://www.google.com/maps/?q=".concat(venue.latitude, ",").concat(venue.longitude),
    target: "_blank",
    rel: "noopener noreferrer",
    className: "link"
  }, "View Map"));
};
EventVenue.propTypes = {
  venue: PropTypes.shape({
    name: PropTypes.string,
    website: PropTypes.string,
    street: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    zip: PropTypes.string,
    phone: PropTypes.string,
    latitude: PropTypes.string,
    longitude: PropTypes.string
  })
};

var EventArtist = function EventArtist(_ref) {
  var artist = _ref.artist;
  return /*#__PURE__*/React.createElement("div", {
    className: "eventInfo-artist"
  }, /*#__PURE__*/React.createElement("h2", null, "Artist"), /*#__PURE__*/React.createElement("a", {
    target: '_blank',
    rel: "noopener noreferrer",
    href: artist.website
  }, /*#__PURE__*/React.createElement("div", {
    className: "link-plain"
  }, artist.name)), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("a", {
    target: '_blank',
    rel: "noopener noreferrer",
    href: artist.facebook,
    className: "link"
  }, "Facebook"), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("a", {
    target: '_blank',
    rel: "noopener noreferrer",
    href: artist.twitter,
    className: "link"
  }, "Twitter"));
};
EventArtist.propTypes = {
  artist: PropTypes.shape({
    name: PropTypes.string,
    facebook: PropTypes.string,
    twitter: PropTypes.string,
    website: PropTypes.string
  })
};

var EventPrices = function EventPrices(_ref) {
  var prices = _ref.prices,
    ticketLink = _ref.ticketLink;
  return /*#__PURE__*/React.createElement("div", {
    className: "eventInfo-prices"
  }, /*#__PURE__*/React.createElement("h2", null, "Event tickets"), prices.map(function (price, i) {
    return /*#__PURE__*/React.createElement("div", {
      key: i,
      className: "eventInfo-price"
    }, price.description, ": $", price.price);
  }), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("a", {
    target: '_blank',
    rel: "noopener noreferrer",
    href: ticketLink,
    className: "link"
  }, "Buy Tickets here"));
};
EventPrices.propTypes = {
  prices: PropTypes.arrayOf(PropTypes.shape({
    price: PropTypes.string.isRequired,
    description: PropTypes.string
  })),
  ticketLink: PropTypes.string
};

var EventDates = function EventDates(_ref) {
  var eventDates = _ref.eventDates;
  return /*#__PURE__*/React.createElement("div", {
    className: "eventInfo-dates"
  }, /*#__PURE__*/React.createElement("h2", null, "Event Dates"), /*#__PURE__*/React.createElement("ul", null, eventDates.map(function (event, i) {
    return /*#__PURE__*/React.createElement("li", {
      className: "eventInfo-date",
      key: i
    }, /*#__PURE__*/React.createElement(Time, {
      dateTime: event.date,
      formatString: "MMMM D, YYYY"
    }));
  })));
};
EventDates.propTypes = {
  eventDates: PropTypes.arrayOf(PropTypes.shape({
    date: PropTypes.string,
    description: PropTypes.string
  }))
};

var EventInfo = function EventInfo(_ref) {
  var venue = _ref.venue,
    artist = _ref.artist,
    prices = _ref.prices,
    ticketLink = _ref.ticketLink,
    eventDates = _ref.eventDates;
  return /*#__PURE__*/React.createElement("div", {
    className: "eventInfo"
  }, venue && /*#__PURE__*/React.createElement(EventVenue, {
    venue: venue
  }), artist && /*#__PURE__*/React.createElement(EventArtist, {
    artist: artist
  }), prices && /*#__PURE__*/React.createElement(EventPrices, {
    prices: prices,
    ticketLink: ticketLink
  }), eventDates && /*#__PURE__*/React.createElement(EventDates, {
    eventDates: eventDates
  }));
};
EventInfo.propTypes = {
  artist: PropTypes.object,
  venue: PropTypes.object,
  prices: PropTypes.array,
  ticketLink: PropTypes.string,
  eventDates: PropTypes.array
};

// TODO: Find some way to do this without the <br/>s?

var Event = function Event(_ref) {
  var title = _ref.title,
    subtitle = _ref.subtitle,
    headingLevel = _ref.headingLevel,
    publishDate = _ref.publishDate,
    tag = _ref.tag,
    bodyHtml = _ref.bodyHtml,
    venue = _ref.venue,
    artist = _ref.artist,
    prices = _ref.prices,
    website = _ref.website,
    eventDates = _ref.eventDates;
  return /*#__PURE__*/React.createElement("div", {
    className: "event"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col col-page"
  }, title && /*#__PURE__*/React.createElement(EventHeader, {
    title: title,
    headingLevel: headingLevel,
    publishDate: publishDate,
    tag: tag,
    subtitle: subtitle
  }), /*#__PURE__*/React.createElement("br", null), bodyHtml && /*#__PURE__*/React.createElement(Body, {
    elementClass: "event_body",
    bodyHtml: bodyHtml
  }), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(EventInfo, {
    title: title,
    venue: venue,
    artist: artist,
    prices: prices,
    ticketLink: website,
    eventDates: eventDates
  })));
};
Event.propTypes = {
  artist: PropTypes.shape({
    name: PropTypes.string,
    facebook: PropTypes.string,
    twitter: PropTypes.string,
    website: PropTypes.string
  }),
  bodyHtml: PropTypes.string,
  eventDates: PropTypes.arrayOf(PropTypes.shape({
    date: PropTypes.string.isRequired,
    description: PropTypes.string
  })),
  headingLevel: PropTypes.number,
  prices: PropTypes.arrayOf(
  // TODO: Should the price be a float (or at least a number) instead of a string?
  PropTypes.shape({
    price: PropTypes.string.isRequired,
    description: PropTypes.string
  })),
  publishDate: PropTypes.node,
  tag: PropTypes.shape({
    tagName: PropTypes.string,
    to: PropTypes.string
  }),
  subtitle: PropTypes.string,
  title: PropTypes.string.isRequired,
  venue: PropTypes.shape({
    name: PropTypes.string,
    website: PropTypes.string,
    street: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    zip: PropTypes.string,
    phone: PropTypes.string,
    latitude: PropTypes.string,
    longitude: PropTypes.string
  }),
  website: PropTypes.string
};

var EventTeaser = function EventTeaser(_ref) {
  var id = _ref.id,
    title = _ref.title,
    headingLevel = _ref.headingLevel,
    eventDates = _ref.eventDates,
    venue = _ref.venue;
  return /*#__PURE__*/React.createElement("div", {
    className: "eventTeaser"
  }, /*#__PURE__*/React.createElement("div", {
    className: "eventTeaser_header"
  }, id && /*#__PURE__*/React.createElement(TitanLink, {
    href: "/".concat(id),
    className: "event_topic link-plain"
  }, title && /*#__PURE__*/React.createElement(Heading, {
    level: headingLevel ? headingLevel : 4
  }, title)), eventDates && /*#__PURE__*/React.createElement(EventDates, {
    eventDates: eventDates
  }), venue && /*#__PURE__*/React.createElement(EventVenue, {
    venue: venue
  })));
};
EventTeaser.propTypes = {
  eventDates: PropTypes.arrayOf(PropTypes.shape({
    date: PropTypes.string.isRequired,
    description: PropTypes.string
  })),
  id: PropTypes.number.isRequired,
  headingLevel: PropTypes.number,
  title: PropTypes.string,
  venue: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    street: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    zip: PropTypes.string,
    longitude: PropTypes.string,
    latitude: PropTypes.string
  })
};

var Video = function Video(_ref) {
  var video = _ref.video,
    hideCaption = _ref.hideCaption;
  var videoPlayer = video && getVideoPlayer(video);
  return /*#__PURE__*/React.createElement("div", {
    className: "content_primaryVisual"
  }, /*#__PURE__*/React.createElement("figure", {
    className: "figure"
  }, video && videoPlayer, video.caption && /*#__PURE__*/React.createElement("figcaption", {
    className: "figure_caption"
  }, /*#__PURE__*/React.createElement("div", {
    className: "figure_caption_content"
  }, video.caption), !hideCaption && video.credit.name && video.credit.url && /*#__PURE__*/React.createElement("a", {
    href: video.credit.url,
    target: "_blank",
    rel: "noreferrer"
  }, /*#__PURE__*/React.createElement("span", {
    className: "figure_credit"
  }, video.credit.name)), video.credit.name && !video.credit.url && /*#__PURE__*/React.createElement("span", {
    className: "figure_credit"
  }, video.credit.name))));
};
Video.propTypes = {
  video: PropTypes.object,
  hideCaption: PropTypes.bool
};

var Teaser = function Teaser(_ref) {
  var title = _ref.title,
    headingLevel = _ref.headingLevel,
    publishDate = _ref.publishDate,
    href = _ref.href,
    as = _ref.as,
    tag = _ref.tag,
    audioPlayButton = _ref.audioPlayButton,
    image = _ref.image,
    video = _ref.video,
    contributors = _ref.contributors,
    description = _ref.description,
    elementClass = _ref.elementClass,
    hideVideoCaption = _ref.hideVideoCaption;
  var classes = classNames(_defineProperty({
    teaser: true
  }, elementClass, elementClass));
  return /*#__PURE__*/React.createElement("article", {
    className: classes
  }, tag && /*#__PURE__*/React.createElement(TagLink, {
    elementClass: "teaser_tagLink",
    to: tag.to,
    tagName: tag.tagName
  }), audioPlayButton && /*#__PURE__*/React.createElement("div", {
    className: "teaser_button"
  }, audioPlayButton), /*#__PURE__*/React.createElement(TitanLink, {
    href: href,
    as: as,
    className: "teaser_link"
  }, video ? /*#__PURE__*/React.createElement(Video, {
    video: video,
    hideCaption: hideVideoCaption
  }) : /*#__PURE__*/React.createElement("div", {
    className: "teaser_image"
  }, image), /*#__PURE__*/React.createElement("div", {
    className: "teaser_content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "teaser_header"
  }, /*#__PURE__*/React.createElement(Heading, {
    level: headingLevel
  }, title)), (publishDate || contributors) && /*#__PURE__*/React.createElement("div", {
    className: "teaser_meta"
  }, publishDate && /*#__PURE__*/React.createElement("div", {
    className: "teaser_pubdate"
  }, publishDate), contributors && /*#__PURE__*/React.createElement("div", {
    className: "teaser_contributors"
  }, "By ".concat(toSentence(contributors)))), description && /*#__PURE__*/React.createElement("div", {
    className: "teaser_body userContent"
  }, description))));
};
Teaser.propTypes = {
  audioPlayButton: PropTypes.node,
  contributors: PropTypes.arrayOf(PropTypes.string),
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  elementClass: PropTypes.string,
  headingLevel: PropTypes.number.isRequired,
  href: PropTypes.string.isRequired,
  as: PropTypes.string,
  image: PropTypes.object,
  video: PropTypes.object,
  publishDate: PropTypes.node,
  tag: PropTypes.shape({
    to: PropTypes.string.isRequired,
    tagName: PropTypes.string.isRequired
  }),
  title: PropTypes.string.isRequired,
  hideVideoCaption: PropTypes.bool
};

exports.Body = Body;
exports.Button = Button;
exports.Content = Content;
exports.Event = Event;
exports.EventTeaser = EventTeaser;
exports.Figure = Figure;
exports.Heading = Heading;
exports.Link = TitanLink;
exports.Loading = Loading;
exports.Pagination = Pagination;
exports.TagLink = TagLink;
exports.Teaser = Teaser;
exports.Time = Time;
